
// requiring html templates so that hot reloading works
const template = require('./offline.html');

const NS = 'OfflineMessage'; // jshint ignore:line

export default function OfflineMessage() { // as offlineMessage
  "ngInject";

  return {
    restrict: 'E',
    replace: true,
    controller: function ($scope) {
      "ngInject";

      const vm = this;

      vm.errorList = [];

      vm.getDetails = function () {
        vm.errorList = vm.detailsFunc();
      };
    },
    controllerAs: 'vm',
    template,
    bindToController: true,
    scope: {
      small: '<',
      retryFunc: '<',
      detailsFunc: '<'
    }
  };
}
